<template>
    <div v-if="show" class="mask">
        <div class="dlg-upfile flex flex-col">
        <div class="flex flex-space-between full-width">
          <div class="font-bold">上传文件</div>
          <div class="pointer" @click="close"><img class="logo-22" src="@/assets/images/guanbi.png"/></div>
        </div>
        <div @dragover="fileDragover" @drop="fileDrop" class="flex flex-col border margin-top-l border-radius-ms scroll padding-l " style="height:370px">
            <input hidden accept="*.*" type="file" ref="fileadd" @change="getfile" />
            <div class="flex flex-center-sp" style="margin-top:125px"><img style="height:45px;height:45px" src="@/assets/images/up-file.png"/></div>
            <div class="flex flex-center-sp margin-top-l">
                <span class="font-bold font-l">将文件拖放在此处或</span>
                <span class="font-bold font-l color-blue under-line pointer" @click="up">点击上传</span></div>
            <div class="flex flex-center-sp font-bold font-l" v-if="fileName">{{ fileName }}</div>
            <div class="flex flex-center-sp margin-top-l color-gray">支持.pdf .docx .xlsx .pptx格式文件，大小不超过100M</div>
        </div>
      </div>
    </div>
</template>

<script>
    export default{
        name:'UpFile',
        props: {
          show: {},
        },
        data() {
            return {
                batchFile:null,
                fileName:null,
                MAX_FILE_SIZE: 10 * 1000 * 1000,
            }
        },
        methods:{
            close() {
                this.$emit("close");
            },
            up() {
                this.$refs.fileadd.click();
            },
            getfile() {
                this.currentfile = this.$refs.fileadd.files[0];
                this.$emit("change", this.currentfile);
            },
            // 拖拽上传
            fileDragover (e) {
                e.preventDefault()
            },
            fileDrop (e) {
                e.preventDefault()
                const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
    
                if (!file) return
                if (file.size > this.MAX_FILE_SIZE) {
                return alert('文件大小不能超过10M')
                }
    
                this.batchFile = file
                this.fileName = file.name
            },
        }
    }
</script>

<style scoped>

    .dlg-upfile {
            border-radius: 5px;
            width: 600px;
            height: 450px;
            background-color: #fff;
            padding: 20px;
            /* 使用绝对地位，父级元素必须有定位属性 */
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
    }
  

</style>


// WEBPACK FOOTER //
// src/modules/upFile/UpFile.vue